import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse,
    HttpHeaders
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { GlobalService } from '../services/global_variable.service';
import { AuthserviceService } from '../guard/authservice.service';
import { Router } from '@angular/router';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
    constructor(
        private spinner: NgxSpinnerService,
        private _globalService: GlobalService,
        private auth: AuthserviceService,
        public router: Router
    ) { }

    IGNORE_URLS = [
        { url: `${this._globalService.BaseUrl}api/Master/UploadPictureBase64_V1`, method: 'POST' },
        { url: `${this._globalService.BaseUrl}api/Master/UserTestTimeUpdate`, method: 'GET' }
    ];


    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        if (this.auth.getToken()) {
            request = request.clone({
                setHeaders: { Authorization: 'bearer ' + this.auth.getToken()}
            });
        }

        let showLoader = true;
        for (const url of this.IGNORE_URLS) {
            if (request.url.startsWith(url.url) && request.method === url.method) {
                showLoader = false;
                break;
            }
        }
        if (showLoader) {
            this.spinner.show();
        }

        return next.handle(request).pipe(
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    this.spinner.hide();
                }
                if (event instanceof HttpResponse) {
                    if (event.status === 401) {
                        this.router.navigate(['/login']);
                    }                }

                return event;
            }),
            catchError((error: HttpErrorResponse) => {
                this.spinner.hide();
                return throwError(error);
            }));
    }
}
